import { Field, Image, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import ContactDetailsItem from 'src/types/ContactDetailsItem';

import EmailIconSvg from 'public/icons/Email.svg';

import styles from './contentOverviewLeadCard.module.css';

type ContentOverviewLeadCardProps = {
	lead: ContactDetailsItem;
	index: number;
	pageTitle?: string;
	contactEmailAddressText: Field<string>;
	contactEmailSubjectText: Field<string>;
};

export default function ContentOverviewLeadCard(props: ContentOverviewLeadCardProps): JSX.Element {
	return (
		<div className={styles.resourceLeadCard} key={props.index}>
			<div className={styles.resourceLeadCardTextContainer}>
				<div className={styles.resourceLeadNameContainer}>
					<Text tag="h1" field={props.lead.fields?.FirstName} className={styles.resourceLeadName} />
					&nbsp;
					<Text tag="h1" field={props.lead.fields?.LastName} className={styles.resourceLeadName} />
				</div>
				<Text tag="p" field={props.lead.fields?.Role} className={styles.resourceLeadCardInfoText} />

				{props.lead.fields?.EmailAddress?.value && (
					<div className={styles.resourceLeadEmailContainer}>
						<span className={styles.resourceLeadEmailWrapper}>
							{props.lead?.fields?.AlternativeContactEmailText?.value ? (
								<Text field={props.lead?.fields?.AlternativeContactEmailText} />
							) : (
								<a
									href={`mailto:${props.lead.fields.EmailAddress.value}?subject=${props.contactEmailSubjectText?.value?.replace(
										'$pageTitle$',
										props.pageTitle ?? ''
									)}`}
									className={styles.resourceLeadEmail}
								>
									{props.contactEmailAddressText?.value}&nbsp;{props.lead.fields.FirstName?.value}
								</a>
							)}
						</span>
						<EmailIconSvg className={styles.resourceLeadEmailIcon} />
					</div>
				)}
			</div>
			{props.lead.fields?.Photo?.value?.src ? (
				<Image media={props.lead.fields?.Photo?.value} alt={props.lead.fields?.Photo?.value?.alt} className={styles.profileImage} />
			) : (
				<div className={`${styles.profileImage} ${styles.noProfileImage}`}>{props.lead.fields?.FirstName?.value.charAt(0)}</div>
			)}
		</div>
	);
}
